
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Plus, MessageSquare, BadgePercent, FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@/components/ui/use-toast';

const QuickActions: React.FC = () => {
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleCreateAppointment = () => {
    navigate('/doctor-area/appointments?action=create');
    toast({
      title: "Create Appointment",
      description: "You can now create a new appointment",
    });
  };

  const handleAddStory = () => {
    navigate('/doctor-area/stories/new');
    toast({
      title: "Add New Story",
      description: "Create a new professional story",
    });
  };

  const handleViewReviews = () => {
    navigate('/doctor-area/reviews?filter=pending');
    toast({
      title: "Pending Reviews",
      description: "Viewing your pending reviews",
    });
  };

  const handleCreateAd = () => {
    navigate('/doctor-area/ads?tab=purchase');
    toast({
      title: "Create Advertisement",
      description: "Start creating a new advertisement",
    });
  };

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Quick Actions</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          <Button 
            variant="outline" 
            className="h-auto py-4 flex flex-col items-center justify-center text-center space-y-1"
            onClick={handleCreateAppointment}
          >
            <Plus className="h-5 w-5" />
            <span className="text-xs">Create Appointment</span>
          </Button>
          
          <Button 
            variant="outline" 
            className="h-auto py-4 flex flex-col items-center justify-center text-center space-y-1"
            onClick={handleAddStory}
          >
            <FileText className="h-5 w-5" />
            <span className="text-xs">Add Story</span>
          </Button>
          
          <Button 
            variant="outline" 
            className="h-auto py-4 flex flex-col items-center justify-center text-center space-y-1"
            onClick={handleViewReviews}
          >
            <MessageSquare className="h-5 w-5" />
            <span className="text-xs">Pending Reviews</span>
          </Button>
          
          <Button 
            variant="outline" 
            className="h-auto py-4 flex flex-col items-center justify-center text-center space-y-1"
            onClick={handleCreateAd}
          >
            <BadgePercent className="h-5 w-5" />
            <span className="text-xs">Create Ad</span>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default QuickActions;
